import confetti from "canvas-confetti";
import { PiggyBank, TrendingUp, ShieldCheck, Hand, Rocket, Sprout, Flower2, TreePine, Trees, Award, Home, Users, HeartHandshake } from "lucide-react";

export const BADGE_ICONS = { PiggyBank, TrendingUp, ShieldCheck, Hand, Rocket, Sprout, Flower2, TreePine, Trees, Award, Home, Users, HeartHandshake };

const GREEN = ["#10B981", "#14b8a6", "#34d399", "#a7f3d0", "#ffffff"];

export function celebrate() {
  confetti({ particleCount: 70, spread: 65, origin: { y: 0.7 }, colors: GREEN });
}

export function bigCelebrate() {
  const end = Date.now() + 700;
  (function frame() {
    confetti({ particleCount: 5, angle: 60, spread: 55, origin: { x: 0 }, colors: GREEN });
    confetti({ particleCount: 5, angle: 120, spread: 55, origin: { x: 1 }, colors: GREEN });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}
